import { buildActivityOperationPath } from "@/modules/dashboard/payments-activity/utils/activityLinks";

export const PAYOUT_BATCHES_PATH = "/app/payout-batches";

export const batchPath = (id: string): string => `${PAYOUT_BATCHES_PATH}/${id}`;

export const newBatchPath = (): string => `${PAYOUT_BATCHES_PATH}/new`;

/** The payments-activity drawer of one payout — where a row's money can be followed after the batch. */
export const payoutActivityPath = (payoutId: string): string =>
  buildActivityOperationPath("payouts", payoutId);

/** Short display id for a uuid: `#f3b1c2d4`. */
export const shortBatchId = (id: string): string => `#${id.slice(0, 8)}`;
